import HttpService from "@/utils/httpData"
export default {
    filter(pageIndex, pageSize, userId, classId, subjectId, keywords) {        
        let params = {
            pageIndex: pageIndex,
            pageSize: pageSize,
            userId: userId,
            classId: classId,
            subjectId: subjectId,
            keyword: keywords
        }
        let apiEndpoint = `QuestionAnswer/filter`;
        return HttpService.get(apiEndpoint, params)
                .then(res => {
                    return res ? res : null;
                })
                .catch(e => {return false}
        );
    },

    getById(id) {
        let params= {
            id: id
        }
        let apiEndpoint = `QuestionAnswer/getById`;
        return HttpService.get(apiEndpoint, params)
                .then(res => {
                    return res ? res : null;
                })
                .catch(e => {return false}
        );
    },

    add(data) {
        let params= data;
        let apiEndpoint = `QuestionAnswer/add`;
        return HttpService.post(apiEndpoint, params)
                .then(res => {
                    return res ? res : null;
                })
                .catch(e => {return false}
        );
    },

    edit(data) {
        let params= data;
        let apiEndpoint = `QuestionAnswer/edit`;
        return HttpService.post(apiEndpoint, params)
                .then(res => {
                    return res ? res : null;
                })
                .catch(e => {return false}
        );
    },

    delete(id) {
        let params= {
            id: id
        }
        let apiEndpoint = `QuestionAnswer/delete`;
        return HttpService.post(apiEndpoint, params)
                .then(res => {
                    return res ? res : null;
                })
                .catch(e => {return false}
        );
    },

    like(questionAnswerId, userId) {
        
        let params= {
            questionAnswerId: questionAnswerId,
            userId: userId
        }
        let apiEndpoint = `QuestionAnswer/like`;
        return HttpService.post(apiEndpoint, params)
                .then(res => {
                    return res ? res : null;
                })
                .catch(e => {return false}
        );
    },

}